import Path2DPolyfill from "./Path2DPolyfill.js";

let g;
try {
    g = window;
} catch (e) {
    g = null;
}

const _Path2D =
    (g && g.Path2D) || Path2DPolyfill.polyfill(g && g.CanvasRenderingContext2D && g.CanvasRenderingContext2D.prototype);

export default _Path2D;

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function patchContext(ctx) {
    Path2DPolyfill.polyfill(Object.getPrototypeOf(ctx));
}
